import { MapfreButtonComponent } from '../../../../modules/mapfre-design-library/src/lib/_components/individual-components/inputs/mapfre-button/mapfre-button.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { Component, OnInit } from '@angular/core';

import { UserService } from '../../../../_services/user.service';
import { ClientCredentialsService } from '../../../../_services/client-credentials/client-credentials.service';
import { ClientCredentialsTokenService } from '../../../../_services/client-credentials/client-credentials-token.service';
import { ValidateEmailService } from '../../../../_services/signup-process-service/validate-email.service';
import { AcmicService, AlertService } from '@mapfre-design-library/src/public_api';
import { Router, ActivatedRoute , RouterModule } from '@angular/router';
import { ErrorRedirectionService } from '../../../../_services/error-service/error-redirection.service';
import { EmailService } from '@services/email/email.service';
import { ParamHandlingService } from '@services/misc-services/param-handling.service';
@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, MapfreButtonComponent],
  selector: 'app-validate-email-screen',
  templateUrl: './validate-email-screen.component.html',
})
export class ValidateEmailScreenComponent implements OnInit {
  email: any;
  user_detail: any = [];
  inactiveAccount = false;
  isAcmic: boolean;
  queryParams: {[key:string]:string};
  utmQueryParams: { [key: string]: string; };
  constructor(
    private alertService: AlertService,
    private _userService: UserService,
    private validateEmailService: ValidateEmailService,
    private clientCredentialsTokenService: ClientCredentialsTokenService,
    private clientCredentialsService: ClientCredentialsService,
    public router: Router,
    private acmicService: AcmicService,
    private activatedRoute: ActivatedRoute,
    private errorRedirectionService: ErrorRedirectionService,
    private emailService: EmailService,
    private paramHandlingService: ParamHandlingService
  ) {}

  ngOnInit() {
    this.user_detail = this._userService.getUserInfoInStorage();
    this.isAcmic = this.acmicService.isACMIC();

    if (this.user_detail) {
      const emailId = this.user_detail['userDetails']['email'];
      this.email = emailId ? this.emailService.maskEmail(emailId) : null;
    } else {
      this.activatedRoute.queryParams.subscribe((params) => {
        this.email = params['email'];
        this.queryParams = params;
        this.inactiveAccount = params['inactive'];
        if (!this.email) {
          this.router.navigate(['login']);
        }
      });
    }
    this.utmQueryParams =  this.paramHandlingService.getUtmQueryParams();

    if (!this.clientCredentialsTokenService.getToken()) {
      this.clientCredentialsService.getToken().subscribe();
    }
  }
  onError(error) {
    this.errorRedirectionService.errorHandler(
      error,
      'VERIFICATION_EMAIL_ERROR'
    );
  }
  sendEmailForInActiveAccount() {
    this.validateEmailService.sendValidationEmail(this.email).subscribe(
      () => {
        this.alertService.success('VERIFICATION_EMAIL_SENT');
      },
      (error) => {
        this.onError(error);        
      }
    );
  }
  // call sendEmailForInActiveAccount to activate in active accounts
  sendEmailForNonCommercial(emailId) {
    this.validateEmailService
      .sendValidationEmailForNonCommercial(emailId)
      .subscribe(
        () => {
          if(this.isAcmic && Object.keys(this.utmQueryParams).length ) {
            this.router.navigate(['/signup', 'validate-account'], { queryParams: this.utmQueryParams, queryParamsHandling: 'merge'});
          } else {
            this.router.navigate(['/signup', 'validate-account']);
          }
        },
        (error) => {
          this.onError(error);
        }
      );
  }
  sendEmail() {
    if (this.inactiveAccount) {
      this.sendEmailForInActiveAccount();
    } else {
      const emailId = this.user_detail['userDetails']['email'];
      this.sendEmailForNonCommercial(emailId);
    }
  }

  sendToAccountVerification(): void {
    this.router.navigate(['signup', 'acount-verification']);
  }
}
